import { reactivePick } from '@vueuse/shared';
import type { PropType, ExtractPropTypes } from 'vue';

import { type RequirementVariantType, requirementVariantList } from '../../typings/requirementVariantType';
import { defaults } from '../defaults';
import { withInputDescriptionProps } from '../props/inputDescription';

/**
 *  Propsy do labela
 *
 *  @export
 *  @returns
 */
export const withLabelProps = {
  ...withInputDescriptionProps,

  /**
   * Treść labelu
   */
  label: { type: String },

  /**
   * Klasa dla labela
   */
  labelClass: { type: String, required: false },

  /**
   * Wypełnia pole `for`, które wskazuje na id elementu, do którego label się odnosi
   */
  forId: { type: String },

  /**
   * Wyświetlaj label w jednej linii w elementem
   */
  labelInline: { type: Boolean, defaults: false },

  /**
   * Czy pole jest wymagane
   */
  isRequired: { type: Boolean, default: false },

  /**
   * Czy pokazywać tekst o wymagalności
   */
  showRequirementText: { type: Boolean, default: true },

  /**
   * Rodzaj powiadomienia o wymagalności (wymagane/opcjonalne)
   */
  requirementVariant: { type: String as PropType<RequirementVariantType>, default: defaults.label.requirementVariant },

  /**
   * Treść powiadomienia o wymagalności
   */
  requirementText: { type: String }
};

/**
 * Wartości do przekazania do w-icon
 *
 * @export
 * @param {*} [props={}]
 * @returns
 */
export function useLabelProps(props: ExtractPropTypes<typeof withLabelProps>) {
  return reactivePick(
    props,
    'description',
    'descriptionVariant',
    'descriptionId',
    'label',
    'labelClass',
    'forId',
    'isRequired',
    'requirementVariant',
    'requirementText',
    'showRequirementText'
  );
}

/**
 * Konfiguracja dla storybooka
 */
export const storiesLabelArgs = {
  args: {
    label: 'Przykładowy label z propsa',
    labelClass: '',
    isRequired: false,
    requirementVariant: defaults.label.requirementVariant,
    requirementText: '',
    labelInline: false
  },

  argTypes: {
    label: {
      control: { type: 'text' }
    },

    labelClass: {
      control: { type: 'text' }
    },

    isRequired: {
      control: { type: 'boolean' }
    },

    showRequirementText: {
      control: { type: 'boolean' }
    },

    requirementVariant: {
      options: requirementVariantList,
      control: { type: 'select' }
    },

    requirementText: {
      control: { type: 'text' }
    },

    labelInline: {
      control: { type: 'boolean' }
    }
  }
};
